var $buoop = {
	required: { e: 88, f: 88, o: 75, s: 13, c: 89 }, // Specifies required browser versions
	insecure: true,
	unsupported: false,
	api: 2021.07,
	reminder: 24, // Hours until message will reappear if displayed
	reminderClosed: 168, // Hours until message will reappear if explicity ignored
	onclose: function(infos) {
		element = document.getElementById("buorg");
    	element.className = "buorg buorg-fadeout";
		setTimeout(function(){
			element.classList.remove("buorg-fadeout");
		}, 1000);
	},
	test: false,
	url: null, // URL redirect after clicking update button
	jsshowurl: "//browser-update.org/update.show.min.js",
	no_permanent_hide: true, // Do not give the user the option to permanently hide the notification
	style: "bottom",
	text: {
		'msg': 'Your web browser ({brow_name}) is out of date.',
    	'msgmore': 'Update your browser for improved security, speed and the best user experience.', 
    	'bupdate': 'Update browser', 
    	'bignore': 'Ignore',
    	'remind': 'You will be reminded in {days} days.',
    	'bnever': 'Never show again'  
	}
};

function $buo_f(){ 
	var e = document.createElement("script"); 
	e.src = "//browser-update.org/update.min.js"; 
	document.body.appendChild(e);
};

try { document.addEventListener("DOMContentLoaded", $buo_f, false) }
catch(e){ window.attachEvent("onload", $buo_f) }